export default __webpack_public_path__ + "static/media/clock-icon.ab86e1ff.svg";